export enum CookiesKeys {
  csrftoken = 'csrftoken',
  isTorusUsed = 'isTorusUsed',
  walletAddress = 'walletAddress',
  termsOfServiceConsentsAccepted = 'termsOfServiceConsentsAccepted',
  nftRenderVideoJobIds = 'nftRenderVideoJobIds',
  nftRenderVideoUrls = 'nftRenderVideoUrls',
  newsletterAgreement = 'newsletterAgreement',
}
